import React from 'react'

// use with onKeyDown
export function onEnter(cb: any) {
  return (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') cb()
  }
}
